<template>
  <a-spin :spinning="formOption.busy">
    <a-form :form="form"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 10 }"
    >
      <a-row :gutter="15">
        <a-col>
          <a-form-item label="计划拜访年月" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
            <a-date-picker
                picker="month"
                v-decorator="['planVisitTime', rules.planVisitTime]"
                format="YYYY-MM"
                value-format="YYYY-MM"
                placeholder="请选择计划拜访年月"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="15">
        <a-col>
          <a-form-item label="责任人用户编号" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
            <a-input placeholder="请输入责任人用户编号" v-decorator="['responsibleUserCode', rules.responsibleUserCode]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="15">
        <a-col>
          <a-form-item label="客户名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
            <a-input placeholder="请输入客户名称" v-decorator="['customerName', rules.customerName]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button type="primary" @click="submit">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import { formMixin, fmt } from '@/utils/common/FormBase'
import { dataApi } from "@/services/bigCustomer/visitTask"

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    planVisitTime: {
      rules: [{required: true, message: "选择计划拜访年月"}]
    },
    responsibleUserCode: {
      rules: [{required: true, message: "请输入责任人用户编号"}]
    },
    customerName: {
      rules: [{required: true, message: "请输入客户名称"}]
    }
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    notify: true
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  let entities = null;
  const vm = this
  this.form.validateFieldsAndScroll((err, values) => {
    if (!err) {//无任何错误 向下执行
      entities = values;
    }
  });
  entities.id = vm.rowId;
  console.log(entities);
  if (entities.id === 0) {
    await dataApi.insertData(entities).then(res => {
      if (res.code === 200) {
        this.$emit('saved')
      } else {
        this.$message.error(res.msg)
      }
    })
  } else {
    await dataApi.updateData(entities).then(res => {
      if (res.code === 200) {
        this.$emit('saved')
      } else {
        this.$message.error(res.msg)
      }
    })
  }
}

/**
 * 加载基础数据
 */
async function loadBaseData() {

}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  data() {
    return {
      id: null
    }
  },
  mounted() {

  },
  methods: {
    loadEntity,
    newEntity,
    submit,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
  }
};
</script>
